import { gql } from '@apollo/client';

import client from '../../../core/services/graphql';

export const GET_COMPANIES = gql`
  query Companies($offset: Int, $limit: Int) {
    companies(offset: $offset, limit: $limit) {
      id
      name
      projects {
        id
        name
        testType
        createdAt
      }
    }
  }
`;

export const getCompanies = async () => {
  const { data } = await client.getClient().query({
    query: GET_COMPANIES,
  });

  return data;
};

export const GET_PROJECT = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      name
      description
      testType
      status
      sessionDuration
      audienceParticipants
      ndaRequired
      studyContext
      otherTesterRequirements
      surveys {
        id
        surveyType
        questions {
          id
          questionType
          label
          groupId
        }
      }
      testers {
        id
        screenerSession {
          id
          screenerSessionAnswers {
            id
            questionId
            questionOptionId
          }
        }
        testSessions {
          id
          videoKey
          videoUrl
          status
          approved
          testSessionAnswers {
            id
            updatedAt
            question {
              id
            }
            questionOptions {
              id
            }
            valueInteger
            videoStartTime
            videoEndTime
          }
        }
        user {
          id
          profile {
            id
            firstName
            lastName
            linkedinFields {
              educationLevel
              currentPosition {
                title
              }
            }
            gender
            birthdate
            country
            state
            raceEthnicHeritage
            annualHouseholdIncome
            paymentMethod
          }
        }
      }
    }
  }
`;

export const getProject = async (id) => {
  const { data } = await client.getClient().query({
    query: GET_PROJECT,
    variables: { id },
    fetchPolicy: 'network-only',
  });

  return data;
};

const GET_ANALYTICS_DATA_QUERY = gql`
  query Analytics($projectId: ID!) {
    analytics(projectId: $projectId) {
      location {
        label
        qty
      }
      age {
        label
        qty
      }
      ethnicity {
        label
        qty
      }
      gender {
        label
        qty
      }
      householdIncome {
        label
        qty
      }
      jobTitle {
        label
        qty
      }
      industry {
        label
        qty
      }
      seniority {
        label
        qty
      }
      companySize {
        label
        qty
      }
      taskDifficulty {
        firstName
        lastName
        testerId
        questionOrder
        questionGroupId
        questionGroupName
        difficulty
        difficultyPerTask
      }
      quotes {
        quoteId
        testerId
        questionId
        questionGroupName
        sentence
        important
        sentimentBySentence
        sentimentByTask
        sentimentByParticipant
        videoTime
        removed
        profileId
      }
    }
  }
`;

export const getAnalyticsByProjectId = async (projectId) => {
  const { data } = await client.getClient().query({
    query: GET_ANALYTICS_DATA_QUERY,
    variables: { projectId },
    fetchPolicy: 'network-only',
  });

  return data.analytics;
};

export const REMOVE_QUOTE = gql`
  mutation RemoveQuote($id: ID!){
    removeQuote(id: $id){
      quoteId
    }
  }
`;
